import { createContext } from 'react';
import { WidgetHost } from '@/core/widgets/model/widget-host';
import { preferencesApi } from '@/core/preferences/export';

export const WidgetHostContext = createContext<WidgetHost>({
  addWidgetById(id: string) {
    console.warn('Noop widget host called');
  },
  removeWidgetById(id: string) {
    console.warn('Noop widget host called');
  },
  get activeWidgetIds(): string[] {
    return [];
  },
  get hostId(): string {
    return 'no-host';
  },
  get currentViewId(): string {
    return 'default-view';
  },
  async setWidgetPath(id: string, path: string) {
    console.warn('Noop widget host called');
  },
  registerWidgetNavigator(id: string, navigate: (path: string) => void): () => void {
    console.warn('Noop widget host called', 'registerWidgetNavigator', id);
    return () => {};
  },
  registerActiveWidgetSelector(select: (id: string, path?: string) => void): () => void {
    console.warn('Noop widget host called', 'registerActiveWidgetSelector');
    return () => {};
  },
  async getWidgetPreferences<T>(id: string): Promise<T> {
    return (await preferencesApi.getPreferences(`widget-${id}`)) || ({} as T);
  },
  async saveWidgetPreferences<T>(id: string, t: T): Promise<T> {
    return preferencesApi.upsertPreferences(`widget-${id}`, t);
  },
});
